export default __webpack_public_path__ + "static/media/insole.89594d37.png";